import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import { BrandingHead } from "@/components/BrandingHead";
import { Protected } from "@/components/Protected";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import { ForgotPassword, ResetPassword } from "@/pages/PasswordReset";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Dashboard from "@/pages/Dashboard";
import { MyPayments, NewPayment, Profile } from "@/pages/UserPages";
import Settings from "@/pages/Settings";
import Wallet from "@/pages/Wallet";
import VirtualCards from "@/pages/VirtualCards";
import PublicPay from "@/pages/PublicPay";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import QrApprove from "@/pages/QrApprove";
import { UserMessages, AdminMessages } from "@/pages/Messages";
import {
  AdminDashboard, AdminUsers, AdminPayments, AdminPaymentRequests,
  AdminStripe, AdminBranding, AdminSettings, AdminAuditLog, AdminCards, AdminPayouts,
} from "@/pages/AdminPages";
import "@/App.css";

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme === "light" ? "light" : "dark"} position="top-right" richColors />;
}

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <BrandingHead />
        <ThemedToaster />        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/pay/:lid" element={<PublicPay />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/qr/:sid" element={<QrApprove />} />
          <Route path="/politika-privatnosti" element={<PrivacyPolicy />} />

          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
          <Route path="/cards" element={<Protected><VirtualCards /></Protected>} />
          <Route path="/payments" element={<Protected><MyPayments /></Protected>} />
          <Route path="/payments/new" element={<Protected><NewPayment /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/messages" element={<Protected><UserMessages /></Protected>} />

          <Route path="/admin/login" element={<Login admin />} />
          <Route path="/admin/dashboard" element={<Protected admin><AdminDashboard /></Protected>} />
          <Route path="/admin/users" element={<Protected admin><AdminUsers /></Protected>} />
          <Route path="/admin/payments" element={<Protected admin><AdminPayments /></Protected>} />
          <Route path="/admin/payment-requests" element={<Protected admin><AdminPaymentRequests /></Protected>} />
          <Route path="/admin/cards" element={<Protected admin><AdminCards /></Protected>} />
          <Route path="/admin/payouts" element={<Protected admin><AdminPayouts /></Protected>} />
          <Route path="/admin/messages" element={<Protected admin><AdminMessages /></Protected>} />
          <Route path="/admin/stripe" element={<Protected admin><AdminStripe /></Protected>} />
          <Route path="/admin/branding" element={<Protected admin><AdminBranding /></Protected>} />
          <Route path="/admin/settings" element={<Protected admin><AdminSettings /></Protected>} />
          <Route path="/admin/audit-log" element={<Protected admin><AdminAuditLog /></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
